export const basePathName = '/api'

/* Auth */
export const authSignUpPath = basePathName + '/auth/sign-up'
export const authLoginPath = basePathName + '/auth/login'
export const authLogoutPath = basePathName + '/auth/logout'
export const authMePath = basePathName + '/auth/me'

export const projectBasePathName = '/api/project'
/* Project */
export const projectIndexPath = projectBasePathName + '/'
export const projectCreatePath = projectBasePathName + '/store'
export const projectShowPath = '/show'
export const projectEditPath = '/update'
export const projectDeletePath = '/delete'

export const userBasePathName = '/api/user'
export const userEditPathName = userBasePathName + '/update'
export const userUpdatePasswordPathName = userBasePathName + '/password/update'

